import { Actions_, Grey_Link, Main_, Red_ } from 'monica-alexandria'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const NotifySliderAction = styled.div`

    img{
        width: 90%;
        margin: 0 auto 2rem auto;
        max-width: 30rem;
        display: block;
    }

    h3{
        text-align: center;
        color: var(--main);
    }

    button{
        margin: 1rem auto 0 auto;
    }
`

const NotifySliderActionFooter = styled.div`
    border-top: 2px solid var(--grey);
    padding-top: 2rem;
    margin-top: 4rem;

    button{
        margin: 0 auto;
    }
`

export default function Notify_Slider_Action(props) {
    const {t} = useTranslation();

    return (
      <NotifySliderAction>
          <img src={props.img} />
          <h3>{props.title}</h3>
          <Grey_Link noPadding text={props.text} onClick={props.onClickGrey} iconRight={props.iconSub ? props.iconSub : "Xicon"}/>
          <NotifySliderActionFooter>
                {props.textRed ? (<Red_ noPadding text={props.textRed} onClick={props.onRed} iconRight={props.iconRed ? props.iconRed : "Delete"} />) : null }
          </NotifySliderActionFooter>
      </NotifySliderAction>
    )
  }